<div class="verify-page">
  <mat-card class="verify-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Verify Account</mat-card-title>
      <mat-card-subtitle>Enter the OTP code from your email</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="verifyForm" (ngSubmit)="onSubmit()" class="verify-form">
        <div class="field">
          <mat-form-field appearance="outline">
            <mat-label>OTP Code</mat-label>
            <input matInput formControlName="otp" inputmode="numeric" autocomplete="one-time-code" />
          </mat-form-field>

          @if(verifyForm.get('otp')?.invalid && (verifyForm.get('otp')?.dirty || verifyForm.get('otp')?.touched)) {
          @if(verifyForm.get('otp')?.errors?.['required']) {
          <div class="error">OTP code is required.</div>
          }
          @if(verifyForm.get('otp')?.errors?.['minlength']) {
          <div class="error">OTP code must be at least 6 digits.</div>
          }
          }
        </div>

        <button mat-flat-button type="submit" color="primary" class="submit-btn" [disabled]="isSubmitting()">
          @if (isSubmitting()) { Verifying... } @else { Verify OTP }
        </button>
      </form>

      @if (errorMessage()) {
      <div class="error-message">{{ errorMessage() }}</div>
      }
      @if (successMessage()) {
      <div class="success-message">{{ successMessage() }}</div>
      }

      <div class="links">
        <a class="back-link" routerLink="/otp">Request OTP</a>
        <a class="back-link" routerLink="/login">Back to Login</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
